export interface DeviceSpec {
  id: string;
  name: string;
  width: number;
  height: number;
  category: "iphone" | "ipad" | "watch";
  required: boolean;
}

export const DEVICES: DeviceSpec[] = [
  {
    id: "iphone-6.9",
    name: 'iPhone 6.9" (16 Pro Max)',
    width: 1260,
    height: 2736,
    category: "iphone",
    required: true,
  },
  {
    id: "iphone-6.5",
    name: 'iPhone 6.5" (11 Pro Max)',
    width: 1242,
    height: 2688,
    category: "iphone",
    required: false,
  },
  {
    id: "ipad-13",
    name: 'iPad 13" (Pro M4)',
    width: 2064,
    height: 2752,
    category: "ipad",
    required: false,
  },
  {
    id: "watch-series10",
    name: "Apple Watch Series 10",
    width: 416,
    height: 496,
    category: "watch",
    required: true,
  },
  {
    id: "watch-ultra2",
    name: "Apple Watch Ultra 2",
    width: 410,
    height: 502,
    category: "watch",
    required: false,
  },
];

export interface VideoSpec {
  id: string;
  name: string;
  width: number;
  height: number;
  duration: string;
  format: string;
}

export const VIDEO_SPECS: VideoSpec[] = [
  {
    id: "iphone-video",
    name: 'iPhone 6.9"',
    width: 886,
    height: 1920,
    duration: "15-30s",
    format: "H.264 MP4, 30fps",
  },
  {
    id: "ipad-video",
    name: 'iPad 13"',
    width: 1200,
    height: 1600,
    duration: "15-30s",
    format: "H.264 MP4, 30fps",
  },
];
